import type { Agent } from "./fixtures";
import { StatusDot } from "./badges";

/**
 * Scope chip — the chat input's "talking to ● {Agent}" signal (Agents Phase 4, piece 3).
 * Rendered by the chat composer's `ChatScopeBar`; the × clears the scope back to the general
 * workspace. Visual scoping only — message routing is deferred/live work.
 *
 * (The old self-contained `ScopedChat` preview rail lived here too; it was retired in the
 * module-as-window cleanup — refining an agent now happens in the real chat, not a second
 * input surface inside the module.)
 */
export function ScopeChip({
  agent,
  onClear,
}: {
  agent: Agent | null;
  onClear?: () => void;
}) {
  if (!agent) {
    return (
      <div className="agui-scopechip agui-scopechip--general">
        <span>general workspace</span>
      </div>
    );
  }
  return (
    <div className="agui-scopechip" style={{ borderColor: agent.color }}>
      <StatusDot color={agent.color} status={agent.status} />
      <span>talking to {agent.name}</span>
      {onClear ? (
        <button
          type="button"
          className="agui-scopechip__x"
          aria-label="Clear scope"
          onClick={onClear}
        >
          ×
        </button>
      ) : null}
    </div>
  );
}
